export type TelegramDiagnostics = {
  telegramPresent: boolean;
  webAppPresent: boolean;
  initDataPresent: boolean;
  initDataLength: number;
  authRequestStarted: boolean;
  authResponseStatus: number | null;
  meResponseStatus: number | null;
  platform: string;
};

const initial: TelegramDiagnostics = {
  telegramPresent: false,
  webAppPresent: false,
  initDataPresent: false,
  initDataLength: 0,
  authRequestStarted: false,
  authResponseStatus: null,
  meResponseStatus: null,
  platform: 'unknown',
};

let current = initial;
const listeners = new Set<() => void>();

export function getTelegramDiagnostics(): TelegramDiagnostics { return current; }
export function subscribeTelegramDiagnostics(listener: () => void): () => void { listeners.add(listener); return () => listeners.delete(listener); }
export function updateTelegramDiagnostics(patch: Partial<TelegramDiagnostics>): void {
  current = { ...current, ...patch };
  listeners.forEach(listener => listener());
}
